import {
    createColumnsDict,
    Table,
    TableColumn,
    TableColumnConfig,
    TableColumnsDefMap
} from '../../components/tables/table';
import {DisplayDexRate} from './dex-display-rate.factory';

export type DexDevRatesTable = Table<DexDevRatesTableColumnKey, DisplayDexRate>;

export enum DexDevRatesTableColumnKey {
    PAIR = 'PAIR',
    RATE = 'RATE',
    DATE = 'DATE'
}

export interface DexDevRatesTableColumn extends TableColumn {
    key: DexDevRatesTableColumnKey;
}

export interface DexDevRatesTableColumnConfig extends TableColumnConfig {
    key: DexDevRatesTableColumnKey;
}

export const DEX_DEV_RATES_TABLE_COLUMNS_DEF: DexDevRatesTableColumn[] = [
    {
        label:      'Pair',
        key:        DexDevRatesTableColumnKey.PAIR,
        isRequired: true,
        width:      '10%'
    },
    {
        label:      'Rate',
        key:        DexDevRatesTableColumnKey.RATE,
        isRequired: true,
        width:      '10%'
    },
    {
        label: 'Updated At',
        key:   DexDevRatesTableColumnKey.DATE,
        isHiddenByDefault: true,
        width: '10%'
    }
];

export const DEX_DEV_RATES_TABLE_COLUMNS_DICT: TableColumnsDefMap<DexDevRatesTableColumnKey, DexDevRatesTableColumn> =
                 createColumnsDict(DEX_DEV_RATES_TABLE_COLUMNS_DEF);
